"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row_1 = require("../wizards/components/Row");
const ReportCount = ({ benchmark, clickHandler, count, device, label, linkId }) => (React.createElement(Row_1.default, { key: linkId, onClick: clickHandler },
    React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-around',
            flexWrap: 'wrap',
            width: '60%',
        } },
        React.createElement(src_1.Text, { label: true, size: "large", text: label, textStyle: { flex: '1 0 100%' } }),
        React.createElement("div", { style: { display: 'flex', width: '100%' } },
            React.createElement(src_1.ProgressBar, { progress: 0, style: {
                    barStyle: {
                        width: '100%',
                    },
                    containerStyle: {
                        width: `${100 * (count / benchmark)}%`,
                        flex: 'none',
                        marginRight: 8,
                        minWidth: 12,
                    },
                    progressStyle: {
                        backgroundColor: src_1.turquoise,
                        float: 'right',
                    },
                } }),
            React.createElement(src_1.Text, { size: "small", text: count.toLocaleString() }))),
    device === 'Desktop' && React.createElement(src_1.EyeIcon, { height: "24", width: "24", fill: src_1.turquoise })));
exports.default = ReportCount;
